import { render, staticRenderFns } from "./A3BoardDetailsPage.vue?vue&type=template&id=dadbc4b4&"
import script from "./A3BoardDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./A3BoardDetailsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dadbc4b4')) {
      api.createRecord('dadbc4b4', component.options)
    } else {
      api.reload('dadbc4b4', component.options)
    }
    module.hot.accept("./A3BoardDetailsPage.vue?vue&type=template&id=dadbc4b4&", function () {
      api.rerender('dadbc4b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/A3/A3BoardDetailsPage.vue"
export default component.exports